module.exports = __webpack_public_path__ + "img/011.904ba20a.png";